import posthog from "posthog-js";

export function currentPosthogSessionId(): string | undefined {
  try {
    const sessionId =
      typeof posthog.get_session_id === "function" ? posthog.get_session_id() : undefined;
    return sessionId || undefined;
  } catch {
    return undefined;
  }
}
